// Shared constants for the QuickBooks module selector (Settings + Sync pages).

import type { TabItem } from '../../../../components/ui/Tabs/Tabs';

export const QB_MODULE_TABS: TabItem[] = [
  { id: 'collections', label: 'Collections' },
  { id: 'weighbridge', label: 'Weighbridge' },
  { id: 'skip', label: 'Skip' },
];

// Shown on the Weighbridge + Skip tabs. Sync is live for these modules:
// Weighbridge syncs completed tickets (SalesReceipt, or Invoice for account
// tickets); Skip syncs completed + paid jobs as SalesReceipts.
export const QB_MODULE_INACTIVE_NOTE =
  'This module syncs completed transactions to QuickBooks as sales receipts (and invoices for account-payment weighbridge tickets).';
